// tslint:disable:jsx-no-multiline-js (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import { IRostelecomStyleParamsStoreState } from '../../styling/rostelecom-styles-store';
import Radium from '../../styling/rostelecom-radium';

interface IProps {
    styles: IRostelecomStyleParamsStoreState;
    height?: number;
    children?: any;
}

@Radium
class RostelecomDialogFooter extends React.Component<IProps, {}> {
    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        let { height, children } = this.props;
        if (typeof height === 'undefined') {
            height = 31;
        }
        return (
            <div
                style={{
                    position: 'absolute',
                    bottom: -height,
                    width: '100%',
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    backgroundColor: 'transparent'
                }}
            >
                {children}
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default RostelecomDialogFooter;
